module.exports = global["jQuery"] = require("-!/var/www/mtrend/wp-content/themes/mtrend/public/node_modules/source-map-loader/index.js!/var/www/mtrend/wp-content/themes/mtrend/public/node_modules/source-map-loader/index.js!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/source-map-loader!./~/jquery/dist/jquery.js
// module id = 3
// module chunks = 0